/**
 * Don volontaire — lien Stripe « Payment Link » hébergé (le donateur choisit
 * son montant). Aucune clé, aucun backend, aucune surface PCI : le bouton n'est
 * qu'un lien vers une page Stripe.
 *
 * Renseigné au build via `VITE_SUPPORT_URL` (ex. dans `.env.prod` du serveur,
 * ou exporté avant `bun run build`). Tant qu'il est vide, le bouton « Soutenir
 * le projet » ne s'affiche pas — pas de lien mort en prod avant la création du
 * Payment Link dans le dashboard Stripe.
 */
export const SUPPORT_URL: string = (
  (import.meta.env as Record<string, string | undefined>).VITE_SUPPORT_URL ||
  // Lien de don Stripe hébergé (page « le donateur choisit son montant »).
  // Public par nature → valeur par défaut en dur : garantit l'affichage
  // même quand le build ne source pas `.env.prod` (cf. deploy.sh étape 5).
  "https://donate.stripe.com/7sYdR8cke90le1jaBM3oA00"
).trim();
